import React from "react"

import CalendlyWidget from "./CalendlyWidget"

const ScheduleInterview = ({ token }) => (
  <>
    <h1>Schedule Interview</h1>
    <CalendlyWidget token={token} />
  </>
)

export default ScheduleInterview
